export default __webpack_public_path__ + "static/media/detalle-del-ingreso.c0034067.svg";